function initSoldAsSelection() {

  console.log('Selection script alive');

  const dropdown = document.querySelector('.sold-as-dropdown');
  if (!dropdown) return;

  const label = document.querySelector('.sold-as-item-code');
  const hiddenInput = document.getElementById('SoldAsHiddenInput');
  const unitsHidden = document.getElementById('UnitsPerHiddenInput');
  const twoPackHidden = document.getElementById('TwoPackHiddenInput');
  const buttons = dropdown.querySelectorAll('.soldas-btn');

  unitsHidden.removeAttribute('disabled');
  twoPackHidden.removeAttribute('disabled');
  hiddenInput.removeAttribute('disabled');

  if (!buttons.length) return;

  function updateSelection(button, isInitial = false) {

    buttons.forEach(btn => btn.classList.remove('selected'));
    button.classList.add('selected');

    const radio = button.querySelector('input[type="radio"]');
    const value = button.getAttribute('data-title') || '';

    if (radio) {
      radio.checked = true;
    }

    if (label) {
      label.textContent = value;
      label.setAttribute('data-selected-value', value);
    }

    if (hiddenInput) hiddenInput.value = value;

    const mode = (window.soldAsMode || "").toLowerCase();
    const isPairSelected = value.toLowerCase().includes("pair");
    const isCurtainPairType = dropdown.dataset.isCurtainPairType === "true";

    // Determine if this is a pair purchase:
    // - mode is "pair" (only pair option available)
    // - mode is "both" AND pair is selected
    const isPairPurchase = mode === "pair" || (mode === "both" && isPairSelected);

    // For "curtain pair" product type:
    // - Frontend shows as pair, but backend treats as single (units_per = 1, no 2pack)
    if (isCurtainPairType) {
        if (unitsHidden) unitsHidden.value = "1";
        if (twoPackHidden) twoPackHidden.value = "";
    } else {
        if (unitsHidden) {
            unitsHidden.value = isPairPurchase ? "2" : "1";
        }
        if (twoPackHidden) {
            twoPackHidden.value = isPairPurchase ? "2Pack" : "";
        }
    }

    // 🔥 Reset quantity only if NOT initial load (scoped to PDP only, not mini cart)
    if (!isInitial) {
      const productInfo = document.querySelector('product-info');
      const qtyInput = productInfo ? productInfo.querySelector('.quantity__input') : null;
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    // 🔥 Fire change event AFTER state updates
    if (radio) {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 🔥 Update price
    if (window.updateSoldAsPrice) {
      setTimeout(window.updateSoldAsPrice, 50);
    }
  }

  // Click handler
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      updateSelection(this, false);
    });
  });

  /* ============================================
     INITIAL STATE (NO QTY RESET)
  ============================================ */

  const checked = dropdown.querySelector('input[type="radio"]:checked');

  if (checked) {
    updateSelection(checked.closest('.soldas-btn'), true);
  } else if (buttons.length === 1) {
    updateSelection(buttons[0], true);
  }

}

document.addEventListener('DOMContentLoaded', initSoldAsSelection);
document.addEventListener('swup:page:view', initSoldAsSelection);